import { Component, EventEmitter, inject, Output } from '@angular/core';
import {MatDialogModule, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
@Component({
  selector: 'app-bet-status-modal',
  imports: [MatDialogModule, TranslateModule],
  templateUrl: './bet-status-modal.component.html',
  styleUrl: './bet-status-modal.component.scss'
})
export class BetStatusModalComponent {
  @Output() closeModal: EventEmitter<any> = new EventEmitter<any>();
  statusMsg!: string;
  showActions!: boolean;
  readonly dialogRef = inject(MatDialogRef<BetStatusModalComponent>);
  readonly data = inject<any>(MAT_DIALOG_DATA);
}
